/* ProNorth custom collection: loads ALL paginated pages, then instant client-side filter / search / sort / compare / quick-add. Material + needle classification fall back to the product title when metafields are empty. */
(function () {
  var root = document.querySelector('[data-pnc]');
  if (!root) return;
  var grid = root.querySelector('[data-pnc-grid]');
  var facetsEl = root.querySelector('[data-pnc-facets]');
  var activeEl = root.querySelector('[data-pnc-active]');
  var shownEl = root.querySelector('[data-pnc-shown]');
  var emptyEl = root.querySelector('[data-pnc-empty]');
  var sortSel = root.querySelector('[data-pnc-sort]');
  var cfgEl = document.querySelector('[data-pnc-config]');
  var config = []; try { config = JSON.parse(cfgEl.textContent) || []; } catch (e) { config = []; }
  var pager = {}; try { pager = JSON.parse(root.querySelector('[data-pnc-pager]').textContent) || {}; } catch (e) { pager = {}; }

  var ATTR = { type:'type', filament:'filament', brand:'brand', size:'size', material:'material', needle:'needle', product_type:'ptype' };
  var selected = {};
  var cards = [];
  var searchQuery = '';

  var MATCOLOR = { 'PGCL':'#e8896a', 'PGLA':'#8e7cc3', 'PDS':'#9aa0a6', 'NYLON':'#3aaf5c', 'POLYPROPYLENE':'#1f6fb2', 'CHROMIC GUT':'#a9794e', 'GUT':'#e0a92b', 'PTFE':'#b9c0c4', 'SILK':'#33405a' };
  function matNorm(material, ptype, title){
    var s = (material||'').toLowerCase(), p = (ptype||'').toLowerCase(), t = (title||'').toLowerCase();
    function h(x){ return s.indexOf(x) > -1 || p.indexOf(x) > -1 || t.indexOf(x) > -1; }
    if (h('poliglecaprone')||h('monocryl')||h('monoderm')||h('monopro')||h('mono-q')||h('mono q')||h('pgcl')) return 'PGCL';
    if (h('polyglactin')||h('vicryl')||h('polysyn')||h('vilet')||h('vipro')||h('pgla')||h('polyglycolic')||h('pga')||h('polysorb')||h('caprosyn')) return 'PGLA';
    if (h('polydioxanone')||h('pdo')||h('pds')||h('doxipro')) return 'PDS';
    if (h('chromic')) return 'CHROMIC GUT';
    if (h('plain gut')||h('plain-gut')||(h('gut') && !h('chromic'))) return 'GUT';
    if (h('nylon')||h('ethilon')||h('nylopro')||h('riverlon')||h('rivermid')||h('polyamide')) return 'NYLON';
    if (h('polypropylene')||h('prolene')||h('polypro')||h('pronova')||h('surgipro')||h('demepropink')||h('visipro')||h('pvdf')||h('polyvinylidene')) return 'POLYPROPYLENE';
    if (h('ptfe')||h('monotex')||h('polytetra')) return 'PTFE';
    if (h('silk')) return 'SILK';
    return '';
  }
  function matOf(c){ return matNorm(c.getAttribute('data-material'), c.getAttribute('data-ptype'), c.getAttribute('data-title')); }

  function needleCodeOf(c){
    var code = (c.getAttribute('data-needle')||'').trim().toUpperCase();
    if (!code){
      var t = c.getAttribute('data-title') || '';
      var m = t.match(/([A-Za-z]{1,4}-\d{1,2})\s*needle/i) || t.match(/needle\s*[:\-]?\s*([A-Za-z]{1,4}-\d{1,2})/i);
      if (m) code = m[1].toUpperCase();
    }
    return code;
  }
  var TAPER = { RB:1, SH:1, CT:1, CTX:1, TP:1, TF:1, BB:1, UR:1, TG:1, MO:1, GS:1, TQ:1, V:1, OS:1, SKI:1, BV:1, RV:1, CTXB:1 };
  function ntypeOf(c){
    var t = (c.getAttribute('data-title')||'').toLowerCase();
    if (t.indexOf('taper') > -1) return 'taper';
    var code = needleCodeOf(c); if (!code) return '';
    var pfx = code.split('-')[0];
    if (TAPER[pfx]) return 'taper';
    return 'reverse cutting';
  }

  // Searchable text per card: SKU + title + needle + material + brand
  function searchStr(c){
    if (c._pncS) return c._pncS;
    var skuEl = c.querySelector('.pnc__sku');
    var sku = skuEl ? skuEl.textContent : '';
    var s = ((c.getAttribute('data-title')||'') + ' ' + sku + ' ' + (c.getAttribute('data-needle')||'') + ' ' + matOf(c) + ' ' + (c.getAttribute('data-brand')||'') + ' ' + (c.getAttribute('data-material')||'')).toLowerCase();
    c._pncS = s; return s;
  }

  function cap(s){ return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }
  function titleCase(s){ return String(s).split(' ').map(cap).join(' '); }
  function uspRank(s){ var p = s.split('-'); if (p.length === 2 && p[1] === '0' && /^[0-9]+$/.test(p[0])) return parseInt(p[0], 10); return null; }
  function sizeSort(a,b){ var ra = uspRank(a), rb = uspRank(b); if (ra != null && rb != null) return rb - ra; return a.localeCompare(b, undefined, {numeric:true}); }

  function fetchPage(n){
    var params; try { params = new URLSearchParams(window.location.search); } catch (e) { params = new URLSearchParams(); }
    params.set('section_id', pager.section);
    params.set('page', n);
    var url = window.location.pathname + '?' + params.toString();
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nodes = doc.querySelectorAll('[data-pnc-card]');
        [].forEach.call(nodes, function (c) { grid.appendChild(document.importNode(c, true)); });
      })
      .catch(function () {});
  }
  function loadAll(){
    var pages = (pager && pager.pages) ? pager.pages : 1;
    if (!pager.section || pages <= 1) return Promise.resolve();
    var chain = Promise.resolve();
    for (var n = 2; n <= pages; n++) { (function (p) { chain = chain.then(function () { return fetchPage(p); }); })(n); }
    return chain;
  }

  function valuesFor(source){
    if (source === 'material'){ var mm = {}; cards.forEach(function(c){ var x = matOf(c); if (x) mm[x] = true; }); return Object.keys(mm); }
    if (source === 'needletype'){ var nt = {}; cards.forEach(function(c){ var x = ntypeOf(c); if (x) nt[x] = true; }); return Object.keys(nt); }
    if (source === 'needle'){ var nc = {}; cards.forEach(function(c){ var x = needleCodeOf(c); if (x) nc[x] = true; }); return Object.keys(nc); }
    var attr = ATTR[source] || source, map = {}; cards.forEach(function(c){ var raw = c.getAttribute('data-' + attr) || ''; raw.split('|').forEach(function(x){ x = x.trim(); if (x) map[x] = true; }); }); return Object.keys(map);
  }

  function group(g, items, source){
    var wrap = document.createElement('div'); wrap.className = 'pnc-fg';
    var h = document.createElement('div'); h.className = 'pnc-fg__h'; h.textContent = g.label; wrap.appendChild(h);
    var box = document.createElement('div'); box.className = 'pnc-fg__box pnc-fg__box--' + (g.style || 'checkbox');
    items.forEach(function(it){
      var lab = document.createElement('label'); lab.className = 'pnc-opt pnc-opt--' + (g.style || 'checkbox');
      var inp = document.createElement('input'); inp.type = 'checkbox'; inp.value = it.v; inp.setAttribute('data-source', source);
      inp.addEventListener('change', onChange);
      lab.appendChild(inp);
      if (source === 'material' && MATCOLOR[it.v]){ var dot = document.createElement('span'); dot.style.cssText = 'display:inline-block;width:11px;height:11px;border-radius:50%;margin-right:6px;flex:none;border:1px solid rgba(0,0,0,.18);background:' + MATCOLOR[it.v]; lab.appendChild(dot); }
      var sp = document.createElement('span'); sp.textContent = it.label;
      lab.appendChild(sp); box.appendChild(lab);
    });
    wrap.appendChild(box); return wrap;
  }

  function buildFacets(){
    facetsEl.innerHTML = '';
    config.forEach(function(g){
      if (g.source === 'availability'){
        var hasIn = cards.some(function(c){ return c.getAttribute('data-avail') === '1'; });
        var hasOut = cards.some(function(c){ return c.getAttribute('data-avail') === '0'; });
        if (!(hasIn && hasOut)) return;
        facetsEl.appendChild(group(g, [{ v:'1', label:'In stock' }], 'availability'));
        return;
      }
      var vals = valuesFor(g.source);
      if (vals.length < 2) return;
      if (g.source === 'material'){
        var order = ['PGCL','PGLA','PDS','GUT','CHROMIC GUT','NYLON','POLYPROPYLENE','PTFE','SILK'];
        vals.sort(function(a,b){ var ia = order.indexOf(a), ib = order.indexOf(b); if (ia < 0) ia = 99; if (ib < 0) ib = 99; return ia - ib; });
      } else {
        vals.sort(g.source === 'size' ? sizeSort : function(a,b){ return a.localeCompare(b, undefined, {numeric:true}); });
      }
      facetsEl.appendChild(group(g, vals.map(function(v){ return { v:v, label:titleCase(v) }; }), g.source));
    });
  }

  function onChange(){
    selected = {};
    [].forEach.call(root.querySelectorAll('[data-pnc-facets] input:checked'), function(inp){
      var s = inp.getAttribute('data-source'); (selected[s] = selected[s] || []).push(inp.value);
    });
    apply();
  }

  function cardMatches(c){
    if (searchQuery && searchStr(c).indexOf(searchQuery) < 0) return false;
    for (var s in selected){
      var vals = selected[s]; if (!vals.length) continue;
      var ok = false;
      if (s === 'availability'){ ok = c.getAttribute('data-avail') === '1'; }
      else if (s === 'material'){ ok = vals.indexOf(matOf(c)) > -1; }
      else if (s === 'needletype'){ ok = vals.indexOf(ntypeOf(c)) > -1; }
      else if (s === 'needle'){ ok = vals.indexOf(needleCodeOf(c)) > -1; }
      else { var attr = ATTR[s] || s, raw = (c.getAttribute('data-' + attr) || '').split('|'); ok = vals.some(function(v){ return raw.indexOf(v) > -1; }); }
      if (!ok) return false;
    }
    return true;
  }

  function apply(){
    var shown = 0;
    cards.forEach(function(c){ var m = cardMatches(c); c.style.display = m ? '' : 'none'; if (m) shown++; });
    if (shownEl) shownEl.textContent = shown;
    if (emptyEl) emptyEl.hidden = shown !== 0;
    renderActive();
  }

  function renderActive(){
    if (!activeEl) return;
    activeEl.innerHTML = '';
    var any = false;
    Object.keys(selected).forEach(function(s){
      selected[s].forEach(function(v){
        any = true;
        var pill = document.createElement('button'); pill.type = 'button'; pill.className = 'pnc-pill';
        pill.textContent = (s === 'availability' ? 'In stock' : titleCase(v));
        var x = document.createElement('span'); x.textContent = ' ×'; pill.appendChild(x);
        pill.addEventListener('click', function(){
          var inp = root.querySelector('[data-pnc-facets] input[data-source="' + s + '"][value="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]');
          if (inp){ inp.checked = false; onChange(); }
        });
        activeEl.appendChild(pill);
      });
    });
    [].forEach.call(root.querySelectorAll('[data-pnc-clear]'), function(b){ b.hidden = !any; });
  }

  function bindClears(){
    [].forEach.call(root.querySelectorAll('[data-pnc-clear]'), function(b){
      b.addEventListener('click', function(){
        [].forEach.call(root.querySelectorAll('[data-pnc-facets] input:checked'), function(i){ i.checked = false; });
        var si = root.querySelector('[data-pnc-search]'); if (si) si.value = ''; searchQuery = '';
        onChange();
      });
    });
  }

  function bindSearch(){
    var bar = root.querySelector('.pnc__bar-r');
    if (!bar || root.querySelector('[data-pnc-search]')) return;
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:relative;display:inline-flex;align-items:center';
    wrap.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#8a8f8c" stroke-width="2" stroke-linecap="round" style="position:absolute;left:10px;pointer-events:none"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    var si = document.createElement('input');
    si.type = 'search'; si.setAttribute('data-pnc-search', ''); si.setAttribute('aria-label', 'Search this collection');
    si.placeholder = 'Search SKU or name…';
    si.style.cssText = 'border:1px solid #d6dad7;border-radius:8px;padding:8px 12px 8px 32px;font:500 13px/1 var(--text-font-family,Inter,sans-serif);color:#2b2f31;background:#fff;width:210px;max-width:46vw';
    wrap.appendChild(si);
    bar.insertBefore(wrap, bar.firstChild);
    var tmr;
    si.addEventListener('input', function(){
      clearTimeout(tmr);
      tmr = setTimeout(function(){ searchQuery = si.value.trim().toLowerCase(); apply(); }, 120);
    });
  }

  function bindSort(){
    if (!sortSel) return;
    sortSel.addEventListener('change', function(){
      var v = sortSel.value, arr = cards.slice();
      arr.sort(function(a,b){
        if (v === 'price-asc') return (+a.dataset.price) - (+b.dataset.price);
        if (v === 'price-desc') return (+b.dataset.price) - (+a.dataset.price);
        if (v === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
        if (v === 'rating-desc') return (+b.dataset.rating) - (+a.dataset.rating);
        return (+a.dataset.order) - (+b.dataset.order);
      });
      arr.forEach(function(c){ grid.appendChild(c); });
    });
  }

  function bindAdd(){
    [].forEach.call(root.querySelectorAll('[data-pnc-add]'), function(form){
      if (form.dataset.bound) return; form.dataset.bound = '1';
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('button'); btn.disabled = true; btn.textContent = '…';
        fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ id: form.querySelector('[name=id]').value, quantity: 1 }) })
          .then(function(r){ return r.json(); })
          .then(function(){
            btn.textContent = '✓';
            var d = document.querySelector('cart-drawer');
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
            if (d && typeof d.show === 'function'){ try { d.show(); } catch(e){} }
            fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ [].forEach.call(document.querySelectorAll('[data-cart-count],.cart-count,.header__cart-count'), function(el){ el.textContent = cart.item_count; }); }).catch(function(){});
            setTimeout(function(){ btn.textContent = '+'; btn.disabled = false; }, 1400);
          })
          .catch(function(){ btn.textContent = '+'; btn.disabled = false; window.location = '/cart'; });
      });
    });
  }

  var cmpToggle = root.querySelector('[data-pnc-compare-toggle]');
  function selectedCompareCards(){ return cards.filter(function(c){ var cb = c.querySelector('[data-pnc-cb]'); return cb && cb.checked; }); }
  function updateCompareBar(){
    var sel = selectedCompareCards();
    var bar = document.getElementById('pnc-cmpbar');
    if (sel.length < 1){ if (bar) bar.remove(); return; }
    if (!bar){
      bar = document.createElement('div'); bar.id = 'pnc-cmpbar'; bar.className = 'pnc-cmpbar';
      var lab = document.createElement('span'); lab.className = 'pnc-cmpbar__n';
      var go = document.createElement('button'); go.type = 'button'; go.className = 'pnc-cmpbar__go'; go.textContent = 'Compare';
      go.addEventListener('click', openCompare);
      bar.appendChild(lab); bar.appendChild(go); document.body.appendChild(bar);
    }
    bar.querySelector('.pnc-cmpbar__n').textContent = sel.length + ' selected';
  }
  function openCompare(){
    var sel = selectedCompareCards(); if (!sel.length) return;
    var specs = [['Type','type'],['Filament','filament'],['Material','material'],['Size','size'],['Needle','needle']];
    var modal = document.createElement('div'); modal.className = 'pnc-modal';
    var box = document.createElement('div'); box.className = 'pnc-modal__box';
    var close = document.createElement('button'); close.className = 'pnc-modal__x'; close.setAttribute('aria-label','Close'); close.textContent = '×';
    var scroll = document.createElement('div'); scroll.className = 'pnc-modal__scroll';
    var t = document.createElement('table'); t.className = 'pnc-ctab';
    var thead = '<tr><th></th>' + sel.map(function(c){ return '<th>' + c.querySelector('.pnc__title').textContent.trim() + '</th>'; }).join('') + '</tr>';
    var body = '';
    body += '<tr><td>Price</td>' + sel.map(function(c){ var p = c.querySelector('.pnc__price'); return '<td>' + (p ? p.textContent.trim() : '') + '</td>'; }).join('') + '</tr>';
    body += '<tr><td>Rating</td>' + sel.map(function(c){ var r = c.dataset.rating; return '<td>' + (r && r !== '0' ? r : '—') + '</td>'; }).join('') + '</tr>';
    specs.forEach(function(s){ body += '<tr><td>' + s[0] + '</td>' + sel.map(function(c){ var val = s[1] === 'material' ? matOf(c) : (s[1] === 'needle' ? needleCodeOf(c) : c.getAttribute('data-' + s[1])); return '<td>' + (val ? titleCase(val) : '—') + '</td>'; }).join('') + '</tr>'; });
    t.innerHTML = '<thead>' + thead + '</thead><tbody>' + body + '</tbody>';
    scroll.appendChild(t); box.appendChild(close); box.appendChild(scroll); modal.appendChild(box); document.body.appendChild(modal);
    modal.addEventListener('click', function(e){ if (e.target === modal || e.target === close) modal.remove(); });
  }
  function bindCompare(){
    if (!cmpToggle) return;
    cmpToggle.addEventListener('change', function(){
      root.classList.toggle('pnc--compare', cmpToggle.checked);
      [].forEach.call(root.querySelectorAll('.pnc__cb'), function(l){ l.hidden = !cmpToggle.checked; });
      if (!cmpToggle.checked){ [].forEach.call(root.querySelectorAll('[data-pnc-cb]'), function(cb){ cb.checked = false; }); }
      updateCompareBar();
    });
    root.addEventListener('change', function(e){ if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-pnc-cb')) updateCompareBar(); });
  }

  function preselectFromUrl(){
    var _P; try { _P = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (!_P) return;
    var qs = _P.get('q') || _P.get('search');
    if (qs){ var si = root.querySelector('[data-pnc-search]'); if (si){ si.value = qs; searchQuery = qs.trim().toLowerCase(); } }
    var preMap = { type:'type', filament:'filament', material:'material', brand:'brand', size:'size', needle:'needle', needle_profile:'needletype', profession:'profession' };
    var preDid = false;
    Object.keys(preMap).forEach(function (k) {
      var val = _P.get(k); if (!val) return;
      var src = preMap[k];
      [].forEach.call(root.querySelectorAll('[data-pnc-facets] input[data-source="' + src + '"]'), function (inp) {
        if (inp.value.toLowerCase() === val.toLowerCase()) { inp.checked = true; preDid = true; }
      });
    });
    if (preDid || qs) onChange();
  }

  function boot(){
    cards = [].slice.call(root.querySelectorAll('[data-pnc-card]'));
    var totalEl = root.querySelector('.pnc__count');
    if (totalEl) totalEl.innerHTML = '<strong data-pnc-shown>' + cards.length + '</strong> of ' + cards.length + ' products';
    shownEl = root.querySelector('[data-pnc-shown]');
    buildFacets();
    bindSearch();
    bindClears();
    bindSort();
    bindAdd();
    bindCompare();
    preselectFromUrl();
  }

  loadAll().then(boot);
})();
